<template>
  <div class="h-fill bg-f">
    <div v-if="user && user.phone" class="pd-20 text-align-center">
      <div class="text-strong fs-20 mg-t-50 mg-b-10">用户账号：{{ user.phone }}</div>
      <img src="/h5/static/images/logo.png" class="w-60 mg-t-30">
      <div v-if="user.createdAt" class="c-a fs-12 mg-b-5">Anji记忆卡注册时间：{{ user.createdAt }}</div>
      <div v-if="user.anymoCreatedAt">
        <img src="/h5/static/images/anymo-logo.png" class="w-60 mg-t-30">
        <div class="c-a fs-12">Anymo注册时间：{{ user.anymoCreatedAt }}</div>
      </div>
    </div>
    <div class="position-fixed b-0 l-0 r-0 fs-18 c-app-red">
      <div class="pd-20">
        <div>
          注销账户须知：<br>此功能为删除账号，不是退出登录！！<br>此功能为删除账号，不是退出登录！！<br>您在【Anji记忆卡】、【Anymo】
          APP使用此手机号登陆的账号都会被注销，您购买的卡牌/会员/存储在云端的数据等所有信息将被永久删除无法找回。如您只希望退出登录而不销毁账号请返回【设置】页面点击'退出'操作
        </div>
        <div @click="onDestroyClick" class="bg-app-red c-f text-align-center bdr-20 pd-10 fs-18 mg-t-20">我确定删除此账号数据
        </div>
      </div>
    </div>

    <van-dialog v-model="showMathDialog" title="安全验证" show-cancel-button
                confirmButtonText="确认删除" cancelButtonText="再想想"
                :before-close="onMathDialogClose">
      <div class="pd-20">
        <div>要删除的账号是：<strong style="color: #4A8EFC;">{{ user.phone }}</strong>
          请确认要操作的账号是否正确，如果不正确请重启APP。点击【确认删除】后此账号所有信息将永久删除且无法找回！如您只希望退出登录而不销毁账号请返回【设置】页面点击'退出'操作
        </div>
        <div class="mg-t-15 text-align-center fs-18 text-strong">{{ mathA }} + {{ mathB }} = ?</div>
        <van-field v-model="mathAnswer" type="digit" placeholder="请输入计算结果" class="bg-f3f mg-t-10"/>
      </div>
    </van-dialog>

    <div v-if="!$parent.appInner || this.$parent.isIos"
         class="position-fixed t-0 w-fill align-items-center h-50 shadow-2 z-index-999 bg-f">
      <div class="flex-1">
        <van-icon name="arrow-left" class="pd-15" @click="$router.back()"/>
      </div>
      <div class="flex-1 text-align-center">
        注销账号
      </div>
      <div class="flex-1"></div>
    </div>
  </div>
</template>

<script>

import request from '../libs/api.request'

export default {
  name: "destroyUser",
  data() {
    return {
      user: {},
      showMathDialog: false,
      mathA: 0,
      mathB: 0,
      mathAnswer: '',
    }
  },
  methods: {
    mask() {
      try {
        akBridge.callHandler("akUserDestroySuccess");
      } catch (e) {

      }
      document.body.innerHTML = "<h1>您的账号已注销！</h1>";
    },
    generateMathProblem() {
      this.mathA = Math.floor(Math.random() * 10);
      this.mathB = Math.floor(Math.random() * 10);
      this.mathAnswer = '';
    },
    confirmDestroy() {
      this.$toast.loading({message: '正在操作！', duration: 60000, overlay: true});
      request.request({
        url: '/user/confirmDestroy',
        method: 'post'
      }).then(() => {
        this.$toast.clear();
        this.mask();
      }).catch((e) => {
        this.$toast.clear();
        this.$toast(e.message)
      });
    },
    onMathDialogClose(action, done) {
      if (action === 'confirm') {
        const answer = parseInt(this.mathAnswer, 10);
        if (isNaN(answer) || answer !== this.mathA + this.mathB) {
          this.$toast('计算结果不正确，请重新计算');
          this.generateMathProblem();
          done(false);
          return;
        }
        done();
        this.confirmDestroy();
      } else {
        done();
      }
    },
    onDestroyClick() {
      this.generateMathProblem();
      this.showMathDialog = true;
    },
    fetchUserInfo() {
      request.request({
        url: '/user/checkForDestroy',
        method: 'post'
      }).then((data) => {
        this.user = data;
      }).catch((e) => {
        if (e && (e.code === 401 || e.code === 403)) {
          this.$parent.login();
        } else {
          this.$toast(e.message)
        }
      });
    }
  },
  mounted() {
    if (!this.$parent.loginUser && !this.$cookies.get('authToken')) {
      this.$parent.login();
      return;
    }
    this.fetchUserInfo();
  }
}
</script>

<style scoped>

</style>
